<template>
  <nav 
    class="mobile-footer nav fixed-bottom" 
    :class="{ 'mobile-footer--hidden': isScrollHidden }">
    <ul
      v-if="!isParentMember"
      class="nav__list list-unstyled d-flex justify-content-between">
      <li class="nav__item">
        <router-link
          :to="homeRoute"
          class="nav__link pt-2 pb-2"
          :class="{'nav__link--current': currentPageIs(homeRoute)}">
          <span class="nav__icon material-icons">
            home
          </span><span class="nav__text">ホーム</span>
        </router-link>
      </li>
      <li class="nav__item">
        <router-link
          to="/search"
          class="nav__link pt-2 pb-2"
          :class="{'nav__link--current': currentPageIs('/search')}">
          <span class="nav__icon material-icons">
            search
          </span><span class="nav__text">検索</span>
        </router-link>
      </li>
      <li class="nav__item">
        <router-link
          to="/notifications"
          class="nav__link pt-2 pb-2"
          style="position: relative;"
          :class="{'nav__link--current': currentPageIs('/notifications')}">
          <img
            v-if="hasNotifications"
            src="@/assets/images/notification-badge.svg"
            class="notification-badge">
          <span class="nav__icon material-icons">
            notifications
          </span><span class="nav__text">通知</span>
        </router-link>
      </li>
      <li class="nav__item">
        <router-link
          v-if="canAccessEvents"
          to="/events"
          class="nav__link pt-2 pb-2"
          :class="{'nav__link--current': currentPageIsEvents}">
          <span class="nav__icon material-icons">
            event
          </span><span class="nav__text">予定表</span>
        </router-link>
      </li>
    </ul>
    <ul
      v-else
      class="nav__list list-unstyled d-flex justify-content-end">
      <li class="nav__item" />
      <li class="nav__item" />
      <li class="nav__item" />
      <li class="nav__item">
        <div
          v-if="canAccessEvents && currentPageIsEvents"
          class="nav__link pt-2 pb-2"
          :class="{'nav__link--current': currentPageIsEvents}"
          @click="refreshPage">
          <span class="nav__icon material-icons">
            refresh
          </span><span class="nav__text">更新</span>
        </div>
        <router-link
          v-else
          to="/events"
          class="nav__link pt-2 pb-2">
          <span class="nav__icon material-icons">
            refresh
          </span><span class="nav__text">更新</span>
        </router-link>
      </li>
      <li class="nav__item">
        <router-link
          to="/settings"
          class="nav__link pt-2 pb-2"
          :class="{'nav__link--current': currentPageIs('/settings')}">
          <span class="nav__icon material-icons">
            settings
          </span><span class="nav__text">設定</span>
        </router-link>
      </li>
    </ul>
    <div 
      v-if="currentPageIsGoalList"
      class="nav__today">
      <ConditionButton
        :active="isConditionButtonActive"
        @click="onClickConditionButton" />
    </div>
    <div 
      v-else-if="currentPageIsEvents"
      class="nav__today">
      <today-button
        :active="!isDisplayDetail"
        @click="onClickTodayButton">
        {{ isDisplayDetail ? '全体表示' : '詳細表示' }}
      </today-button>
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import TodayButton from '@/components/parts/TodayButton'
import ConditionButton from '@/components/parts/ConditionButton.vue'
import scrollHide from '@/mixins/scrollHide'
export default {
  components: {
    ConditionButton,
    TodayButton
  },
  mixins: [scrollHide],
  computed: {
    ...mapState(['isConditionButtonActive']),
    ...mapState('auth', ['user']),
    ...mapState('events', ['isDisplayDetail']),
    ...mapState(['hasNotifications']),
    ...mapGetters('auth', ['canAccessEvents', 'isParentMember']),
    homeRoute() {
      if (!this.user){
        return '/'
      }
      if (this.user.homeView === 'member_list') {
        return '/members'
      }
      return `/members/${this.user.id}`
    },
    currentPageIsGoalList() {
      return this.$route.name === 'goalList'
    },
    currentPageIsEvents() {
      return this.$route.name === 'events'
    },
  },
  watch: {
    // ルート変更を監視してフッターを表示
    '$route'() {
      this.isScrollHidden = false
    }
  },
  methods: {
    currentPageIs(path) {
      return this.$route.path === path
    },
    onClickConditionButton() {
      this.$store.commit('toggleIsConditionButtonActive')
    },
    onClickTodayButton() {
      const newIsDisplayDetail = !this.isDisplayDetail
      this.$store.commit('events/setIsDisplayDetail', newIsDisplayDetail)

      // 全体 -> 詳細表示の時
      if (newIsDisplayDetail) {
        this.$store.commit('events/setSelectedDate', new Date())
        this.$store.commit('events/setShouldScrollToToday', true)
        return
      }

      // 詳細 -> 全体表示の時
      this.$store.commit('events/setShouldScrollToToday', true)
    },
    refreshPage() {
      window.location.reload()
    },
  }
}
</script>

<style lang="scss" scoped>
// PWAでもfixedが正しく動くように
.mobile-footer {
  position: -webkit-fixed;
  background-color: transparent;
  border: none;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  opacity: 1;
  visibility: visible;

  .nav__list {
    border: none;
    margin: 16px;
    box-shadow: 1px 2px 6px $grey05;
    border-radius: 20px;
    background-color: white;
  }

  .nav__today {
    margin-bottom: 20px;
  }

  // 非表示状態のスタイル
  &.mobile-footer--hidden {
    opacity: 0;
    visibility: hidden;
  }
}
.notification-badge {
  position: absolute;
  top: 8%;
  left: 60%;
  transform: scale(0.8);
}
</style>